import { render } from "./WarikanView.vue?vue&type=template&id=3c1afb56&scoped=true"
import script from "./WarikanView.vue?vue&type=script&lang=js"
export * from "./WarikanView.vue?vue&type=script&lang=js"

import "./WarikanView.vue?vue&type=style&index=0&id=3c1afb56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1afb56"]])

export default __exports__